export default __webpack_public_path__ + "static/paymentIcons-1df3881ff4b2c2b3287377a995f31feb.svg";